// Allen Orthodontics (Oceanside CA) - single office.
// Backend: bondLocations.ts ALLEN_OCEANSIDE (brandId "allen", catalog 19f074ec,
// Edge loc 4, procedure 318, DB 369). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 369). Bilingual (EN + ES).
import type { BrandConfig } from "./types";

export const allen: BrandConfig = {
  slug: "allen",
  brandId: "allen",
  brandName: "Allen Orthodontics",
  logo: "https://drallenortho.com/wp-content/uploads/2023/10/Allen_Logo.png",
  phone: "(760) 724-2722",
  phoneHref: "tel:+17607242722",
  theme: { primary: "#00599B", primaryDark: "#0B3A63" }, // scoured 2026-07-14 drallenortho.com (blue + orange accent)
  locales: ["en", "es"],
  locations: {
    ALLEN_OCEANSIDE: {
      id: "ALLEN_OCEANSIDE",
      name: "Oceanside",
      addressLines: ["1810 Rancho Del Oro Rd, #125", "Oceanside, CA 92056"],
      mapsUrl: "https://maps.google.com/?q=1810+Rancho+Del+Oro+Rd+125+Oceanside+CA+92056",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { OCEANSIDE: "ALLEN_OCEANSIDE", ALLEN: "ALLEN_OCEANSIDE" },
};
